/**
 * Not all properties/functions from window object are mockable.
 * Create this helper function so that we can mock the "getWindow" function
 */
export function getWindow(): Window {
  return window;
}
